
import { defineComponent } from "vue";
import HeroSection from "@/components/home/HeroSection.vue";
import MediasSection from "@/components/home/MediasSection.vue";
import CineMediasSection from "@/components/home/CineMediasSection.vue";
import NewsSection from "@/components/home/NewsSection.vue";
import RegisterAboutSection from "@/components/home/RegisterAboutSection.vue";
import { useHead } from "@vueuse/head";
import { trans } from "@/globals/translator";

export default defineComponent({
  components: {
    HeroSection,
    MediasSection,
    CineMediasSection,
    NewsSection,
    RegisterAboutSection,
  },
  setup() {
    useHead({
      title: trans("general.window_title_template", {
        current_page: trans("general.home"),
      }) as string,
    });
  },
});
